export default [
  // Add your common extenders here
];